<template>
  <div
    class="hm-no-data-card"
    :class="{
      'hm-no-data-card--border': showBorder,
    }"
  >
    <h3 v-if="title">{{ title }}</h3>
    <p v-if="description">{{ description }}</p>
    <router-link
      v-if="toRouteName"
      :to="{
        name: toRouteName,
      }"
    >
      <HMButton color="brand">
        {{ toLabel }}
      </HMButton>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'HMNoDataCard',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    toLabel: {
      type: String,
      default: '',
    },
    toRouteName: {
      type: String,
      default: '',
    },
    showBorder: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.hm-no-data-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 2rem;
  border-radius: $border-radius;
  text-align: center;
  @include media-breakpoint-up(md) {
    min-height: 300px;
  }
  &--border {
    border: 1px solid $light-gray;
  }
}
</style>
